<template>
	<v-form class="profile-form" v-if="form != null" @keyup.enter.prevent="saveForm">
		<v-container pt-0>
			<v-card class="pt-3" dark flat color="transparent">
				<div v-for="formField in formFields" :key="formField.key" class="mb-4">
					<v-text-field
						height="27px"
						color="tertiary"
						:label="formField.label"
						:append-icon="formField.show ? 'visibility_off' : 'visibility'"
						:type="formField.show ? 'text' : 'password'"
						:name="formField.key"
						v-model="form[formField.key]"
						flat
						:hide-details="!form.errors.has(formField.key)"
						:error="form.errors.has(formField.key)"
						:error-count="form.errors.has(formField.key) ? form.errors.get(formField.key).length : 0"
						:error-messages="form.errors.get(formField.key)"
						@keyup.enter.prevent="saveForm"
						@change="form.errors.forget(formField.key)"
						@click:append="hideShowPassword(formField)"
					></v-text-field>
				</div>

				<v-layout justify-space-between>
					<v-btn class="ml-0" flat outline @click="resetForm">Cancel</v-btn>
					<v-btn
						:loading="loading"
						:disabled="loading"
						class="mr-0"
						flat
						outline
						@click.stop="saveForm"
					>Save</v-btn>
				</v-layout>
			</v-card>
		</v-container>
	</v-form>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";

export default {
	data() {
		return {
			loading: false,
			form: null,
			formFields: [
				{
					key: "password",
					label: "Password",
					show: false
				},
				{
					key: "new_password",
					label: "New Password",
					show: false
				},
				{
					key: "new_password_confirmation",
					label: "Confirm New Password",
					show: false
				}
			]
		};
	},

	computed: {
		...mapGetters(["user"])
	},

	methods: {
		...mapMutations(["ADD_NOTIFICATION"]),

		hideShowPassword(field) {
			this.$set(field, "show", !field.show);
		},

		resetForm() {
			this.formFields.forEach(item => {
				this.form[item.key] = "";
				this.form.errors.forget(item.key);
			});
			this.$emit("hide-change-password");
		},

		saveForm() {
			this.loading = true;
			Spark.post("/api/password/reset", this.form)
				.then(({ user }) => {
					let date = Date.now();

					this.loading = false;
					this.$emit("hide-change-password");

					this.ADD_NOTIFICATION({
						show: true,
						type: "success",
						text: `Your password has been changed`,
						id: `password-changed-${date}`
					});
				})
				.catch(error => {
					this.loading = false;
				});
		}
	},

	created() {
		let formData = {};

		this.formFields.forEach(item => {
			formData[item.key] = this.getObjectValue(item.key, this.user);
		});

		this.form = new SparkForm(formData);
	}
};
</script>
